const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchUsers = async ({ limit = 10, offset = 1, query = {} }) => {
  const res = await fetch(`${API_URL}/user/filter`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ limit, offset, query })
  });
  if (!res.ok) throw new Error('Error al obtener usuarios');
  return res.json();
};

export const createUser = async (userData) => {
  const res = await fetch(`${API_URL}/user/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(userData)
  });
  let data;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg = Array.isArray(data?.message)
      ? data.message.join('\n')
      : data?.message || data?.error || 'Error al crear usuario';
    throw new Error(msg);
  }
  return data;
};

export const updateUser = async (id, data) => {
  const res = await fetch(`${API_URL}/user/update`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, data })
  });
  let json;
  try { json = await res.json(); } catch {}
  if (!res.ok) {
    const msg = Array.isArray(json?.message)
      ? json.message.join('\n')
      : json?.message || json?.error || 'Error al actualizar usuario';
    throw new Error(msg);
  }
  return json;
};

export const deleteUser = async (id) => {
  const res = await fetch(`${API_URL}/user/delete/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Error al eliminar usuario');
  return res.json();
};

export const asignarClientesConductor = async (conductorId, clientes) => {
  const res = await fetch(`${API_URL}/user/conductores/${conductorId}/clientes`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientes }),
  });
  let data;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg = Array.isArray(data?.message)
      ? data.message.join('\n')
      : data?.message || 'Error al asignar clientes';
    throw new Error(msg);
  }
  return data;
};

// Módulos habilitados para un usuario. Guardar [] lo devuelve a los permisos
// por defecto de su rol.
export const asignarModulosUsuario = async (usuarioId, modulos) => {
  const res = await fetch(`${API_URL}/user/permisos/${usuarioId}/modulos`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ modulos }),
  });
  let data;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg = Array.isArray(data?.message)
      ? data.message.join('\n')
      : data?.message || 'Error al asignar módulos';
    throw new Error(msg);
  }
  return data;
};

// Centros de lavado visibles para el usuario. [] = sin restricción.
export const asignarCentrosUsuario = async (usuarioId, centros) => {
  const res = await fetch(`${API_URL}/user/permisos/${usuarioId}/centros`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ centros }),
  });
  let data;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg = Array.isArray(data?.message)
      ? data.message.join('\n')
      : data?.message || 'Error al asignar centros';
    throw new Error(msg);
  }
  return data;
};

export const fetchConductores = async (lavanderiaId) => {
  const res = await fetch(`${API_URL}/user/conductores`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lavanderiaId }),
  });
  if (!res.ok) throw new Error('Error al obtener conductores');
  return res.json();
};

export const exportUsers = async (query = {}) => {
  const res = await fetch(`${API_URL}/user/export`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query })
  });
  let data;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg = Array.isArray(data?.message)
      ? data.message.join('\n')
      : data?.message || data?.error || 'Error al exportar usuarios';
    throw new Error(msg);
  }
  return data.data;
};
